import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { injectIntl, FormattedMessage } from 'react-intl';
import { makeStyles, Container, Grid, Paper, Tabs, Tab, CircularProgress } from '@material-ui/core';

import BreadCrumb from 'app/components/BreadCrumb';
import { URLS } from 'app/config/urls';
import GrowingTable from 'app/components/GrowingTable';

import UserForm from './UserForm';

import styles from './styles';
import userEndpoints from 'app/api/services/userEndpoints';
import notification from 'app/config/notification';
import { GenericDrawer } from 'app/components/GenericDrawer/GenericDrawer';
import { errorHandler } from 'app/utils/errorHandler';
import helpers from 'app/utils/helpers';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
const useStyles = makeStyles(styles);

function Users(props) {
  const classes = useStyles();
  const history = useHistory();

  const { intl } = props;
  const [refreshUsers, setRefreshUsers] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [userSelected, setUserSelected] = useState({});
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState(() => {
    return [];
  });

  const registrationUserInfo = useSelector(state => state.auth.registrationInfo);
  const userLogged = useSelector(state => state.auth.user);

  useEffect(() => {
    if (!registrationUserInfo.boAtivo) {
      history.push(URLS.START);
    }
  }, [history, registrationUserInfo.boAtivo]);

  const [tableData, setTableData] = useState({
    columns: [
      {
        title: '',
        field: '',
        align: 'left',
        showContent: () => <></>,
      },
      {
        title: 'Nome',
        field: 'nmUsuario',
        align: 'left',
        showContent: value => {
          return <div>{value && value.nmUsuario}</div>;
        },
      },
      {
        title: 'E-mail',
        field: 'deEmail',
        align: 'left',
        showContent: value => {
          return <div>{value && value.deEmail}</div>;
        },
      },
      {
        title: 'CPF/CNPJ',
        field: 'deCpfCnpj',
        align: 'left',
        showContent: value => {
          return <div>{value && value.deCpfCnpj}</div>;
        },
      },
      {
        title: 'Função',
        field: 'deFuncao',
        align: 'left',
        showContent: value => {
          return <div>{value && value.deFuncao}</div>;
        },
      },
    ],
    data: users,
  });

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const response = await userEndpoints.findUsers();
        if (response.status === 200 && response.data) {
          const users = [];
          const tableDataTemp = { ...tableData };

          let keyLoggedUser = _.findIndex(response.data, ['deCpfCnpj', registrationUserInfo.deCpfCnpj]);

          response.data.forEach((userElem, index) => {
            const temp = { ...userElem };
            temp.deFuncao = 'Administrador';
            temp.hideDeleteButton = true;

            if(index === keyLoggedUser && !userLogged.cdUsuarioAdmin){
              temp.admin = true;
            }

            if (!temp.admin) {
              temp.showEditButton = true;
              temp.hideDeleteButton = false;
              temp.deFuncao = 'Usuário';
            }
            temp.deCpfCnpj = helpers.formatarDocumento(temp.deCpfCnpj);
            users.push(temp);
          });
          tableDataTemp.data = users;
          setUsers(users);
          setTableData(tableDataTemp);
        }
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoading(false);
    };
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshUsers, registrationUserInfo]);

  const addElement = contact => {
    setTableData(contact);
    setUsers(contact.data);
  };

  const onChangeField = (e, index) => {
    const name = e.target.name;
    const value = e.target.value;
    const temp = [...users];
    temp[index][name] = value;
    temp[index]['boPrincipalContato'] = true;
    setUsers(temp);
  };

  const addUser = async index => {
    if (index === undefined) {
      //NEW
      setOpenDrawer(true);
    } else {
      //DELETE
      try {
        if (window.confirm('Deseja continuar?')) {
          setLoading(true);
          const user = users[index];
          const response = await userEndpoints.deleteUser(user);
          if (response.status === 200) {
            setRefreshUsers(Math.random());
          }
          setLoading(false);
        }
      } catch (error) {
        notification('Erro ao excluir usuário.', { type: 'error' });
        setLoading(false);
      }
    }
  };

  const closeDrawer = () => {
    setUserSelected({});
    setOpenDrawer(false);
  };

  const customEditElement = element => {
    setUserSelected(element);
    setOpenDrawer(true);
  };

  const breadCrumb = [
    {
      title: intl.formatMessage({ id: 'LABELS.COMPANY.DATA' }),
      path: URLS.COMPANY,
    },
    {
      title: intl.formatMessage({ id: 'LABELS.COMPANY.USERS' }),
      path: '',
    },
  ];

  const renderTabs = () => {
    return (
      <Grid container spacing={3} className={classes.tabsContainer}>
        <Tabs
          variant="fullWidth"
          className={classes.tabs}
          indicatorColor="primary"
          textColor="primary"
          value={0}
        >
          <Tab className={classes.tab} label={<FormattedMessage id="LABELS.COMMONS.USERS" />} />
        </Tabs>
      </Grid>
    );
  };

  return (
    <>
      <GenericDrawer open={openDrawer} title="Cadastro de Usuário" onClose={() => closeDrawer()}>
        <Container>
          <UserForm
            {...props}
            user={userSelected}
            setRefreshUsers={setRefreshUsers}
            closeDrawer={closeDrawer}
            classes={classes}
          />
        </Container>
      </GenericDrawer>
      <Container>
        <BreadCrumb breadCrumb={breadCrumb} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.container} elevation={3}>
              {renderTabs()}
              {loading && (
                <div className={classes.centerProgress}>
                  <CircularProgress size={20} />
                </div>
              )}
              {!loading && (
                <GrowingTable
                  title=""
                  tabledata={tableData}
                  addtabledata={addElement}
                  customEditElement={customEditElement}
                  handlechange={onChangeField}
                  customAddElement={addUser}
                  canEdit={true}
                />
              )}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default injectIntl(Users);
